import { notification } from "antd";
import { COLORS } from "../../constants";

const Notification = (title, message, type) => {
  switch (type) {
    case "success":
      notification.info({
        message: title,
        description: message,
        placement: "bottomRight",
        style: {
          width: 300,
          backgroundColor: COLORS.green,
        },
      });
      break;
    case "error":
      notification.warning({
        message: title,
        description: message,
        placement: "bottomRight",
        style: {
          width: 300,
          backgroundColor: COLORS.red,
          color: COLORS.black,
        },
      });
      break;

    default:
      notification.info({
        message: title,
        description: message,
        placement: "bottomRight",
        style: {
          width: 300,
          backgroundColor: COLORS.green,
        },
      });
      break;
  }
};

export default Notification;
